// extracted by mini-css-extract-plugin
export default {"header":"VLiyUs","title":"zBL3Ek","mobile":"YOOIcZ","list":"EaYLj6"};